export default __webpack_public_path__ + "static/media/GHSI Shareholders' Policies and Programs Guideline.3b8478d1.pdf";